import {
  APP_SETTING_TOGGLE_DATA_MASKING_BEGIN,
  APP_SETTING_TOGGLE_DATA_MASKING_SUCCESS,
  APP_SETTING_TOGGLE_DATA_MASKING_FAILURE,
  APP_SETTING_TOGGLE_DATA_MASKING_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import { toast } from 'react-toastify';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';
import { getCookie, updateUserIpInCookie } from '../../../common/utils/api_utils';

export function toggleDataMasking(args = {}) {
  return async (dispatch) => {
    dispatch({
      type: APP_SETTING_TOGGLE_DATA_MASKING_BEGIN,
    });
    const { projectId, version } = args;
    const userIp = getCookie('userIp') || (await updateUserIpInCookie());
    const header = builderSurfaceJsonContentHeader(projectId, userIp);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/projects/${projectId}/toggle-data-masking`,
        args.data,
        header,
      );
      doRequest.then(
        (res) => {
          if (res.status === 200 && res.data) {
            dispatch({
              type: APP_SETTING_TOGGLE_DATA_MASKING_SUCCESS,
              data: res.data,
            });
            toast.success('Updated Successfully !', {});
            resolve(res.data);
          } else {
            dispatch({
              type: APP_SETTING_TOGGLE_DATA_MASKING_FAILURE,
              data: { error: 'Failed' },
            });
            const errMsg = getErrorMessageFromResponse(res);
            toast.error(`Failed: ${errMsg}`, {});
            reject('Failed');
          }
        },
        (err) => {
          dispatch({
            type: APP_SETTING_TOGGLE_DATA_MASKING_FAILURE,
            data: { error: err },
          });
          const errMsg = getErrorMessageFromResponse(err.response);
          toast.error(`Failed: ${errMsg}`, {});
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissToggleDataMaskingError() {
  return {
    type: APP_SETTING_TOGGLE_DATA_MASKING_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case APP_SETTING_TOGGLE_DATA_MASKING_BEGIN:
      return {
        ...state,
        toggleDataMaskingPending: true,
        toggleDataMaskingError: null,
      };

    case APP_SETTING_TOGGLE_DATA_MASKING_SUCCESS:
      return {
        ...state,
        toggleDataMaskingPending: false,
        toggleDataMaskingError: null,
        projectDetail: action.data,
      };

    case APP_SETTING_TOGGLE_DATA_MASKING_FAILURE:
      return {
        ...state,
        toggleDataMaskingPending: false,
        toggleDataMaskingError: action.data.error,
      };

    case APP_SETTING_TOGGLE_DATA_MASKING_DISMISS_ERROR:
      return {
        ...state,
        toggleDataMaskingError: null,
      };

    default:
      return state;
  }
}
